module.exports = __webpack_public_path__ + "img/cash.bc44ca06.jpg";